import React from "react";
import type { FieldConfiguration } from "../../../../../../../../../api/types/fieldConfigurationTypes.ts";
import { MeasureDateRange } from "../../../../../../../../../api/types/fieldConfigurationTypes.ts";
import type { MeasureField } from "../../../../../../../../../api/types/svTypes.ts";
import { getMeasureRanges } from "../../../utils/dateRangeToString.ts";
import DateRanges from "../measures/DateRanges.tsx";

interface Props {
  measure: MeasureField;
  onClose: () => void;
  saveChanges: (changes: Partial<FieldConfiguration>, causeClosing: boolean) => void;
  readonly: boolean;
}

export default function PeriodMenuItem({ measure, onClose, saveChanges, readonly }: Props) {
  const updateDateRangeType = React.useCallback(
    (newDateRangeType: MeasureDateRange) => {
      if (measure.config.dateRange === newDateRangeType) {
        onClose();
      } else {
        saveChanges({ dateRange: newDateRangeType }, true);
      }
    },
    [measure, onClose, saveChanges]
  );

  if (!measure.meta.capabilities.dateRangeCustomization) return <></>;

  return (
    <DateRanges
      dateRange={measure.config.dateRange ?? MeasureDateRange.EndingBalance}
      ranges={getMeasureRanges()}
      onChange={updateDateRangeType}
      disabled={readonly}
    />
  );
}
